// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"284b6d0a","238":"e5e627b0","422":"1bb3c7da","546":"867ede11","652":"00ba0705","806":"e0d0ef7e","836":"293faa59"}[chunkId] + ".chunk.js";
};